// extracted by mini-css-extract-plugin
export default {"page_wrapper":"SinglePage_page_wrapper__UKBag","main":"SinglePage_main__QghSJ"};